import queryString from 'query-string';
import { toast } from 'sonner';

import { useApiMutation, useApiQuery, useFetch } from '@/modules/common';

import {
  CreateEventParticipantTypePayload,
  EventParticipantType,
} from '../types';

export function useEventParticipantTypes(eventId: string, enabled: boolean) {
  const fetchClient = useFetch();

  const { data: participantTypes, isFetching } = useApiQuery<
    EventParticipantType[]
  >(`/events/${eventId}/participant-types`, {
    queryKey: ['eventParticipantTypes'],
    initialData: [],
    enabled,
  });

  const createParticipantTypeMutation =
    useApiMutation<CreateEventParticipantTypePayload>(
      `/events/${eventId}/participant-types`,
      {
        method: 'POST',
      },
      {
        onError: (error) => {
          toast.error(error.message);
        },
      }
    );

  const updateParticipantTypeMutation =
    useApiMutation<CreateEventParticipantTypePayload>(
      `/events/${eventId}/participant-types`,
      {
        method: 'PATCH',
      },
      {
        onError: (error) => {
          toast.error(error.message);
        },
      }
    );

  const deleteParticipantTypeMutation = (ids: string[]) => {
    return fetchClient(
      `/events/${eventId}/participant-types?${queryString.stringify({ ids }, { arrayFormat: 'none' })}`,
      {
        method: 'DELETE',
      }
    );
  };

  return {
    isFetching,
    participantTypes,
    deleteParticipantTypeMutation,
    updateParticipantTypeMutation,
    createParticipantTypeMutation,
  } as const;
}
